import { render, staticRenderFns } from "./ResponsibleAuthorities.vue?vue&type=template&id=d4a4ec94&"
import script from "./ResponsibleAuthorities.vue?vue&type=script&lang=js&"
export * from "./ResponsibleAuthorities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports